import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@material-ui/data-grid";
import { getUsersList } from "../utils/Actions";
import { size } from "lodash";
import { Typography, Grid } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import { isEmpty } from "lodash";
import moment from "moment/min/moment-with-locales";
import EditIcon from "@material-ui/icons/Edit";
import { GRID_DEFAULT_LOCALE_TEXT } from "../config/localeDatagrid";
import Switch from "@material-ui/core/Switch";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import { Loading } from "../atoms";
import { Link } from "react-router-dom";
import PeopleIcon from "@material-ui/icons/People";

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
moment.locale("es");

const columns = [
  {
    field: "photo",
    headerName: "Foto",
    renderCell: (params) => (
      <Avatar src={params.value} style={{ width: 30, height: 30 }} />
    ),
    sortable: false,
    width: 81,
  },
  {
    field: "fullName",
    headerName: "Nombre Completo",
    description: "Esta columna no se puede ordener",
    width: 180,
    valueGetter: (params) =>
      `${params.getValue("name") || ""} ${params.getValue("lastname") || ""}`,
  },
  { field: "employeenumber", headerName: "#Usr.", width: 100 },
  {
    field: "rol",
    headerName: "Rol",
    width: 140,
    renderCell: (params) => (
      <Typography> {getRolDescription(params.value)}</Typography>
    ),
  },
  {
    field: "createdAt",
    headerName: "Fecha Creación",
    width: 160,
    renderCell: (params) => (
      <Typography>{moment(params.value).format("ll")}</Typography>
    ),
  },

  {
    field: "status",
    headerName: "Estatus",
    renderCell: (params) => (
      <Switch
        checked={params.value}
        color="primary"
        name="checkedB"
        inputProps={{ "aria-label": "primary checkbox" }}
      />
    ),
    width: 110,
  },
  {
    field: "id",
    headerName: "Acciones",
    width: 120,
    renderCell: (params) => (
      <Link
        to={{
          pathname: `/edituser?id=${params.value}`,
          state: { id: params.value },
        }}
      >
        <EditIcon style={{ fontSize: 25 }} color="primary" />
      </Link>
    ),
    sortable: false,
  },
];

const getRolDescription = (rol) => {
  if (Number(rol) === 1) {
    return "Seguridad";
  } else if (Number(rol) === 2) {
    return "Jefe de Operaciones";
  } else if (Number(rol) === 3) {
    return "Administrador";
  } else {
    return "Cliente";
  }
};

export default function Users() {
  const [state, setstate] = useState([]);
  const [visible, setVisible] = useState(false);
  let history = useHistory();
  const exporterRef = useRef(null);

  useEffect(() => {
    (async () => {
      setVisible(true);
      setstate((await getUsersList()).data);
      setVisible(false);
    })();
  }, []);

  const ExportCSV = ({ csvData, fileName }) => {
    let datauserexport = [];

    csvData.map((item) => {
      const data = {
        ID: item.id,
        RUTA_FOTO: item.photo,
        NOMBRE: item.name,
        APELLIDO: item.lastname,
        USUARIO: item.employeenumber,
        FECHA_CREACION: item.createdAt,
        ROL: getRolDescription(item.rol),
        CUENTA: item.accountAsignedName,
        CREADO_POR: item.createby,
        ESTATUS: item.status ? "Activo" : "Desactivo",
      };
      datauserexport.push(data);
    });

    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    const exportToCSV = (csvData, fileName) => {
      const ws = XLSX.utils.json_to_sheet(datauserexport);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    };

    return (
      <Button
        variant="outlined"
        color="secondary"
        onClick={(e) => exportToCSV(csvData, fileName)}
      >
        Exportar a Excel
      </Button>
    );
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer style={{ justifyContent: "flex-end", height: 80 }}>
        <ExportCSV csvData={state} fileName={"users"} />
        <Button
          variant="contained"
          color="secondary"
          style={{ marginRight: 20, marginLeft: 20 }}
          onClick={gotoAddUser}
        >
          Agregar Nuevo Usuario
        </Button>
      </GridToolbarContainer>
    );
  }

  function gotoAddUser() {
    history.push("/adduser");
  }

  return (
    size(state) > 0 && (
      <Grid
        container
        direction="column"
        style={{ height: "100vh", backgroundColor: "#fff", borderRadius: 5 }}
        xs="12"
      >
        <Typography
          variant="h5"
          style={{
            marginBottom: 30,
            backgroundColor: "#fff",
            padding: 10,
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: 5,
          }}
        >
          <PeopleIcon />
          Administración de Usuarios
        </Typography>

        <DataGrid
          rows={state}
          columns={columns}
          autoPageSize={true}
          localeText={GRID_DEFAULT_LOCALE_TEXT}
          components={{
            Toolbar: CustomToolbar,
          }}
        />
        <Loading visible={visible} setVisible={setVisible} />
      </Grid>
    )
  );
}
